(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-account"] && !Shopify.designMode) return;
  try {
    
  /* ── REMOVE FROM WISHLIST ──
     Posts the updated list to the App Proxy backend, which writes the
     customer metafield via Admin API. Optimistic UI updates first so the
     UX feels instant even if the network is slow. */
  (function(){
    var acct = document.getElementById('dlAcct');
    if (!acct) return;
    var stateEl = document.getElementById('dlAcctWishState');
    if (!stateEl) return;
    var state = {};
    try { state = JSON.parse(stateEl.textContent) || {} } catch(e){}
    var handles = (state.handles || []).slice();

    /* App Proxy endpoint: when the backend Worker is deployed, requests
       to /apps/wishlist/* are forwarded to it (HMAC-signed by Shopify). */
    var APP_PROXY = '/apps/wishlist/save';

    function syncToServer(list){
      return fetch(APP_PROXY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ handles: list })
      }).catch(function(){ /* swallow — UI already updated optimistically */ });
    }

    acct.querySelectorAll('[data-wish-remove]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var handle = btn.dataset.wishRemove;
        if (!handle) return;
        handles = handles.filter(function(h){ return h !== handle });
        /* Optimistic UI — fade out the card */
        var card = btn.closest('.dl-acct__wish-card');
        if (card) {
          card.style.opacity = '0';
          card.style.transform = 'scale(.98)';
          card.style.transition = 'opacity .25s ease, transform .25s ease';
          setTimeout(function(){ card.remove() }, 260);
        }
        syncToServer(handles);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-login"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var auth = document.getElementById('dlAuth');
    if (!auth) return;
    function show(){ auth.classList.add('is-recover') }
    function hide(){ auth.classList.remove('is-recover') }
    document.querySelectorAll('[data-recover-show]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); show(); history.replaceState(null, '', '#recover') });
    });
    document.querySelectorAll('[data-recover-hide]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); hide(); history.replaceState(null, '', '#') });
    });
    if (location.hash === '#recover') show();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-my-wardrobe"] && !Shopify.designMode) return;
  try {
    
  /* ── REMOVE FROM WARDROBE ──
     Posts the updated full list to the App Proxy backend (/apps/wishlist/save),
     which writes the customer metafield via Admin API. Optimistic UI:
     fade the card out immediately so the interaction feels instant. */
  (function(){
    var wd = document.getElementById('dlWd');
    if (!wd) return;
    var stateEl = document.getElementById('dlWardrobeData');
    if (!stateEl) return;
    var state = {};
    try { state = JSON.parse(stateEl.textContent) || {} } catch(e){}
    var handles = (state.wishlist || []).slice();

    var APP_PROXY = '/apps/wishlist/save';

    function syncToServer(list){
      return fetch(APP_PROXY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ handles: list })
      }).catch(function(){ /* swallow — UI already updated optimistically */ });
    }

    wd.querySelectorAll('[data-wish-remove]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var handle = btn.dataset.wishRemove;
        if (!handle) return;
        handles = handles.filter(function(h){ return h !== handle });
        var card = btn.closest('.dl-wd__wish-card');
        if (card) {
          card.style.opacity = '0';
          card.style.transform = 'scale(.98)';
          card.style.transition = 'opacity .25s ease, transform .25s ease';
          setTimeout(function(){
            card.remove();
            /* If grid is empty, swap to the empty state */
            var grid = wd.querySelector('.dl-wd__wish-grid');
            if (grid && grid.children.length === 0) {
              var section = grid.parentNode;
              grid.remove();
              var meta = section.querySelector('.dl-wd__section-meta');
              if (meta) meta.textContent = 'empty';
              var empty = document.createElement('div');
              empty.className = 'dl-wd__empty';
              empty.innerHTML = '<p class="dl-wd__empty-line">Nothing saved yet.</p>' +
                '<p class="dl-wd__empty-sub">As you browse, tap the bookmark on a piece to set it aside.</p>' +
                '<a href="/" class="dl-wd__empty-cta">Discover the collection →</a>';
              section.appendChild(empty);
            } else {
              /* Update item count */
              var meta = wd.querySelector('.dl-wd__section-meta');
              if (meta) {
                meta.textContent = handles.length + ' ' + (handles.length === 1 ? 'item' : 'items');
              }
            }
          }, 260);
        }
        syncToServer(handles);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
